/**
 *
 * Asynchronously loads the component for AnimalsHomePage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AnimalsHomePage = lazyLoad(
  () => import('./index'),
  module => module.AnimalsHomePage,
);
